export default __webpack_public_path__ + "static/media/message.d000bf3c.svg";